import JSbridge from "./JSbridge";
import axios from "axios";
import {isBizChatApp, isIOS} from "../utils/detect";

const API_ENDPOINT = global.API_URI || "http://mm-chat.demo2.mixmedia.com/api";
const http = axios.create({
    baseURL: API_ENDPOINT,
})

http.interceptors.response.use(function (resp) {
    let json = resp.data;
    if (json && json.status == 1) {
        return json.data;
    }
    if (json && json.error) {
        return Promise.reject(json.error);
    }

    return Promise.reject();
});

export default {
    detectUpgrade() {
        JSbridge.getPKGInfo()
            .then((data) => {
                const type = isIOS() ? `ios` : `android`;
                const version = data.version || false;
                if (isBizChatApp() && version) {
                    return http.get(`/app/version?type=${type}&version=${version}`)
                }
                return Promise.reject(`not is webview`);
            })
            .then((data) => {
                if (data.need_upgrade && data.download_link) {
                    if (confirm(`Needs To Be Updated`)) {
                        return JSbridge.browserOpen(data.download_link);
                    }
                }
            })
    }
}